import React from "react"

import Script from "next/script"
import { useTranslation } from "react-i18next"

export interface GdprConsentProps {}

const GdprConsent: React.FC<GdprConsentProps> = () => {
  const { t } = useTranslation()

  const options = {
    /**
     * You must set the cookie name.
     **/
    cookieName: "arezzomedia_gdpr",

    /**
     * The cookie configuration, such as domain and path.
     **/
    cookieConfig: {
      domain: "arezzomedia.com",
      path: "/",
    },

    /**
     * These are the top two lines of text on the banner
     * The 'description' field can include html such as links
     **/
    heading: t("gdpr:heading"),
    description: t("gdpr:description"),

    /**
     * All the button labels
     **/
    acceptLabel: t("gdpr:button.confirmAll"),
    settingsLabel: t("gdpr:button.settings"),
    closeLabel: t("gdpr:button.closeWindow"),

    /**
     * These are the default opt-ins and their descriptions.
     * When value is set to true, the option will automatically be checked on load.
     *
     * If you want to hide a category, simply set it to false, e.g. 'marketing: false'
     **/
    choices: {
      necessary: {
        label: t("gdpr:necessary.label"),
        description: t("gdpr:necessary.description"),
        value: true,
      },
      tracking: false,
      analytics: false,
      marketing: false,
    },

    /**
     * Show an icon to edit cookies later, when banner is closed.
     **/
    showEditIcon: true,

    /**
     * These are the functions which are run if a user opts-in to that category.
     * You should drop your cookies here (or set a variable to control the later dropping of cookies.
     *
     * If you are using svelte, you can use events instead - see the Svelte section below.
     **/
    categories: {
      // analytics: function () {
      //   console.log("No analytics cookies specified")
      // },
      // tracking: function () {
      //   console.log("No tracking cookies specified")
      // },
      // marketing: function () {
      //   console.log("No marketing cookies specified")
      // },
      necessary: function () {
        console.log("No necessary cookies specified")
      },
    },
  }

  return (
    <>
      <Script
        src="https://unpkg.com/@beyonk/gdpr-cookie-consent-banner/dist/browser/bundle.min.js"
        strategy="lazyOnload"
        onLoad={() => {
          // @ts-ignore
          window.GdprConsent.attachBanner(document.body, options)
        }}
      />
    </>
  )
}

export default GdprConsent
